import { Shop } from '../modules/editor/types';

export function sortShopsByOrder(shops: Shop[]): Shop[] {
	return [...shops].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

/**
 * @description 연동 주소록에 매칭되는 shop을 찾는다.
 * 최초 연동 직후에는 /shops 응답의 shop.listId가 아직 null(전파 지연)이라
 * listId 매칭이 실패한다. 이때는 부모(stibee)가 넘겨준 shopId로 우선 매칭하고,
 * shopId가 없으면 listId로 폴백한다.
 */
export function pickLinkedShop(
	shops: Shop[],
	{ shopId, listId }: { shopId?: string | null; listId?: number | null }
): Shop | undefined {
	if (shopId) {
		const byShopId = shops.find((shop) => shop.shopId === shopId);
		if (byShopId) return byShopId;
	}
	if (listId == null) return undefined;
	return shops.find((shop) => shop.listId === listId);
}
